import { SalaryPrice, SalaryGroupHead } from '@/plugins/api'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    search: [],
    salaryPrices: {},
    price: {},
    pageText: '',
    itemsPerPage: 5,
    SearchParams: {},
    totalItems: 0,
    loading: true
  },
  actions: {
    async createTuitionFeePrice({ commit }, payload) {
      try {
        commit('addPrice', await SalaryGroupHead.createPrice(payload))
        alert.addSuccess('kỳ đóng')
      } catch (error) {
        alert.addError(error)
      }
    },
    async getPriceById({ commit }, payload) {
      try {
        commit('getPriceById', await SalaryPrice.fetchOne(payload))
      } catch (error) {console.error(error)}
    },
    async updatePrice({ commit }, payload) {
      try {
        commit('updatePrice', await SalaryPrice.update(payload.id, payload.price))
        alert.updateSuccess()
      } catch (error) {
        alert.updateError()
      }
    },
    async updatePriceIndependent(_, payload) {
      try {
        await SalaryPrice.update(payload.id, payload.price)
        alert.updateSuccess()
        return true
      } catch {
        alert.updateError()
        return false
      }
    },
    async deletePrice({ commit }, payload) {
      try {
        commit('deletePrice', await SalaryGroupHead.removePrice(payload.groupHeadFeeId, { priceId: payload.idPrice }))
      } catch (error) {console.error(error)}
    },
    async setPrices({ commit }, id) {
      try {
        let groupHeadFee = await SalaryGroupHead.fetchOne(id)
        let salaryPrices = groupHeadFee.prices
        commit('setPrices', {
          salaryPrices
        })
        commit('changeState', { loading: false })
      } catch (error) {
        commit('changeState', { loading: true })
      }
    }
  },
  mutations: {
    setHeadFees(state, headFees) {
      state.headFees = headFees
    },
    getPriceById(state, price) {
      state.price = price
    },
    updatePrice(state, price) {
      state.salaryPrices = state.salaryPrices.map(item => (item.id === price.id ? price : item))
    },
    deletePrice(state, headFeeGroup) {
      state.salaryPrices = headFeeGroup.prices
    },
    addPrice(state, price) {
      state.salaryPrices = price.prices
    },
    setPrices(state, salaryPrices) {
      state.salaryPrices = salaryPrices.salaryPrices
    }
  }
}
